import { useEffect } from 'react';

export const DEFAULT_TITLE = 'Sampellegrini & Jaliff — Estudio Jurídico | Abogacía humana, soluciones reales';
export const DEFAULT_DESCRIPTION = 'Estudio jurídico familiar liderado por madre e hija. Especialistas en Derecho de Familia, Sucesiones, Civil y Laboral. Trato humano, soluciones legales sin vueltas. Consultá por WhatsApp.';

export const usePageMeta = (title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, [title, description]);
};
